import { Button } from '../Button.js';
import { Card } from '../Card.js';

export const FeedEmptyState = () => (
  <Card>
    <div className="mx-auto max-w-sm py-4 text-center">
      <p className="text-lg font-medium text-text">Your story starts here</p>
      <p className="mt-2 text-sm leading-6 text-text-secondary">
        Each reading, reflection, and discovery will gather here over time.
      </p>
      <Button href="/spreads" className="mt-5">
        Begin a reading
      </Button>
    </div>
  </Card>
);
